const template = `
  <div class="uoe-container">
    <div class="uoe-content">
      <h3 class="uoe-heading">Error with EdGEL Cookie Consent settings</h3>
      <ul class="uoe-list">
      </ul>
    </div>
  </div>
`

export default template
